/**评价模块 */
import request from '../request/http';
function queryId(){
    return sessionStorage.getItem('institutionTenantId')||'';
}
/**新增课程统计 */
export function GetCourseAddStatistics(){
    return request({
        url: '/sp/dataCenter/getCourseAddStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**课程访问排行 */
export function GetCourseVisitRanking(){
    return request({
        url: '/sp/dataCenter/getCourseVisitRanking',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**课程访问统计 */
export function GetCourseVisitStatistics(){
    return request({
        url: '/sp/dataCenter/getCourseVisitStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**课程收藏统计 */
export function GetCourseCollectStatistics(){
    return request({
        url: '/sp/dataCenter/getCourseCollectStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**资源使用排行 */
export function GetResDataUseRanking(){
    return request({
        url: '/sp/dataCenter/getResDataUseRanking',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**资源使用统计 */
export function GetResDataUseStatistics(){
    return request({
        url: '/sp/dataCenter/getResDataUseStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**资源分类使用统计 */
export function GetResDataClassifyUseStatistics(){
    return request({
        url: '/sp/dataCenter/getResDataClassifyUseStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取资源总使用量 */
export function GetResDataUseTotalUseCount(){
    return request({
        url: '/sp/dataCenter/getResDataUseTotalUseCount',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**资源分类使用占比统计 */
export function GetResDataClassifyUseProportion(){
    return request({
        url: '/sp/dataCenter/getResDataClassifyUseProportion',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**资源类型新增统计 */
export function GetResDataAddStatistics(){
    return request({
        url: '/sp/dataCenter/getResDataAddStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**资源占比 */
export function GetResDataProportion(){
    return request({
        url: '/sp/dataCenter/getResDataProportion',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**平台用户角色分布 */
export function GetPlatformUserRoleDistribution(){
    return request({
        url: '/sp/dataCenter/getPlatformUserRoleDistribution',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**平台用户增长量 */
export function GetPlatformUserAddStatistics(){
    return request({
        url: '/sp/dataCenter/getPlatformUserAddStatistics',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**平台用户活跃度 */
export function GetPlatformUserActive(){
    return request({
        url: '/sp/dataCenter/getPlatformUserActive',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取课程总数 */
export function GetCourseCount(){
    return request({
        url: '/sp/dataCenter/getCourseCount',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取课程收藏数量 */
export function GetCourseCollectCount(){
    return request({
        url: '/sp/dataCenter/getCourseCollectCount',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}